import { X } from 'lucide-react';
import useToastStore from '@/stores/toast-store';

export default function ToastProvider() {
  const { toasts, remove } = useToastStore();

  return (
    <div aria-live="polite" className="fixed bottom-32 right-6 left-6 sm:left-auto z-[99999] flex flex-col gap-3 sm:max-w-xs">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`rounded-lg p-3 shadow-lg border ${t.variant === 'error' ? 'bg-red-50 border-red-200 dark:bg-red-900/80 dark:border-red-800' : 'bg-green-50 border-green-200 dark:bg-green-900/80 dark:border-green-800'}`}>
          <div className="flex items-start gap-2">
            <div className="flex-1">
              {t.title && <div className="font-medium text-green-900 dark:text-green-200">{t.title}</div>}
              {t.description && <div className="text-sm text-green-800 dark:text-green-100 mt-1">{t.description}</div>}
            </div>
            <button onClick={() => remove(t.id)} className="p-1 rounded hover:bg-muted">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
